import styled from 'styled-components'

import { Alignment, FontPreset } from '../styles/mixins'
import { Text } from './Text'

export const H5 = styled(Text)`
  ${FontPreset('h5')};
  ${Alignment({ verticalAlign: 'middle' })};
`
